import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=1d117ea7&scoped=true&"
import script from "./RichEditor.vue?vue&type=script&lang=js&"
export * from "./RichEditor.vue?vue&type=script&lang=js&"
import style0 from "medium-editor/dist/css/medium-editor.css?vue&type=style&index=0&lang=css&"
import style1 from "./theme.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./RichEditor.vue?vue&type=style&index=2&id=1d117ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d117ea7",
  null
  
)

export default component.exports